import Game from "engine/Game";
import EngineProcess from "engine/Process/Utils/EngineProcess";

import "./index.css";

// eslint-disable-next-line quack-engine/no-direct-process-creation
new EngineProcess(new Game(import('src/Main')), {
	fps: 60,
	pauseOnFocusLost: false,//TODO damit bug, bei resizen wird auflösung nicht angepasst und ladebildschirm kann anhalten
	// on focus lost sollte eig triggert, wenn man anderes windows auf hat?
	maximumDelta: 1,
});
